CampoExtraFirmaDirectiva.$inject = [];

export default function CampoExtraFirmaDirectiva() {
    return {
        restrict: 'AE',
        scope: {
            'campoExtra': '=',
            'updateActive': '=',
            'cargando': '=',
            'claseRow': '@'
        },
        template: require('./campos-extra-firma.html'),
        controller: 'CamposExtraFirmaCtrl as campExtFirma',
        bindToController: true
    }
}